var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('login-title'),_c('input-id'),_c('input-password'),_c('button-login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }